import { ActionTypesScreen4 } from "app/constants";

export const defaultState = {
  listData: [],
  objectData: {},
  singleData: null,
};

function Screen4Reducer(state = defaultState, action) {
    switch (action.type) {
        case ActionTypesScreen4.GET_AVERAGE_DATA_SCREEN4:
            return { ...state, averageDataScreen4: action.payload }
        case ActionTypesScreen4.GET_COUNT_DATA_SCREEN4:
            return { ...state, countDataScreen4: action.payload }
        case ActionTypesScreen4.GET_PERCENT_DATA_SCREEN4:
            return { ...state, percentDataScreen4: action.payload }
        case ActionTypesScreen4.GET_GROWTH_DATA_SCREEN4:
            return { ...state, growthDataScreen4: action.payload }
        default:
            return state;
    }
  }
  
export default Screen4Reducer;